<div class="section-container">
    <div class="section-title">
        <mat-icon class="material-symbols-outlined">tune</mat-icon>
        <span>Exceções Cadastradas</span>
        <div class="section-title-actions ms-auto">
            <button mat-button type="button" class="btn-section"
                (click)="abrirWizardExcecao()">
                <mat-icon>add</mat-icon>
                Adicionar exceção
            </button>
        </div>
    </div>

    @if (excoesDisplay.length === 0) {
    <div class="excecoes-empty">
        <mat-icon class="material-symbols-outlined empty-icon">tune</mat-icon>
        <p class="empty-titulo">Nenhuma exceção cadastrada</p>
        <p class="empty-subtitulo">As exceções permitem configurações específicas por produto, destinatário, NCM ou UF, sobrepondo a regra padrão.</p>
    </div>
    } @else {

    <!-- Tabela desktop -->
    <table mat-table class="desktop-view" [dataSource]="excoesDisplay">

        <ng-container matColumnDef="escopos">
            <th mat-header-cell *matHeaderCellDef>Escopos</th>
            <td mat-cell *matCellDef="let exc">
                <div class="badges-row">
                    @for (lbl of exc.escoposLabels; track $index) {
                    <span class="status-badge badge-cinza">{{ lbl }}</span>
                    }
                    @if (exc.escoposLabels.length === 0) {
                    <span class="text-secondary" style="font-size:0.82rem;">—</span>
                    }
                </div>
            </td>
        </ng-container>

        <ng-container matColumnDef="codigoTributo">
            <th mat-header-cell *matHeaderCellDef>Código</th>
            <td mat-cell *matCellDef="let exc">
                @if (exc.cstPis) {
                <span class="status-badge badge-azul">{{ exc.cstPis }}</span>
                } @else {
                <span class="text-secondary" style="font-size:0.82rem;">—</span>
                }
            </td>
        </ng-container>

        <ng-container matColumnDef="vigencia">
            <th mat-header-cell *matHeaderCellDef>Período de Vigência</th>
            <td mat-cell *matCellDef="let exc" class="text-secondary" style="font-size:0.85rem;">
                {{ exc.vigenciaTexto }}
            </td>
        </ng-container>

        <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef class="text-center w-actions">Ações</th>
            <td mat-cell *matCellDef="let exc" class="text-center w-actions">
                <button mat-icon-button [matMenuTriggerFor]="menuExcecao" type="button" aria-label="Ações">
                    <span class="material-symbols-outlined">more_horiz</span>
                </button>
                <mat-menu #menuExcecao="matMenu">
                    <button mat-menu-item (click)="abrirWizardEditar(exc._idx)">
                        <mat-icon class="material-symbols-outlined">edit</mat-icon>
                        <span>Editar</span>
                    </button>
                    <button mat-menu-item (click)="excluirExcecao(exc._idx)">
                        <mat-icon class="material-symbols-outlined">delete</mat-icon>
                        <span>Excluir</span>
                    </button>
                </mat-menu>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <!-- Cards mobile -->
    <div class="mobile-view">
        @for (exc of excoesDisplay; track exc._idx) {
        <div class="card-mobile mb-3">
            <div class="card-header-mobile d-flex justify-content-between align-items-center">
                <div class="d-flex flex-wrap align-items-center gap-1">
                    @for (lbl of exc.escoposLabels; track $index) {
                    <span class="status-badge badge-cinza">{{ lbl }}</span>
                    }
                    @if (exc.escoposLabels.length === 0) {
                    <span class="text-secondary">Sem escopo</span>
                    }
                </div>
                <button mat-icon-button [matMenuTriggerFor]="menuMob" type="button">
                    <span class="material-symbols-outlined">more_horiz</span>
                </button>
                <mat-menu #menuMob="matMenu">
                    <button mat-menu-item (click)="abrirWizardEditar(exc._idx)">
                        <mat-icon class="material-symbols-outlined">edit</mat-icon>
                        <span>Editar</span>
                    </button>
                    <button mat-menu-item (click)="excluirExcecao(exc._idx)">
                        <mat-icon class="material-symbols-outlined">delete</mat-icon>
                        <span>Excluir</span>
                    </button>
                </mat-menu>
            </div>
            <div class="card-body-mobile p-3">
                <p class="mb-1">
                    <strong>Código:</strong>
                    @if (exc.cstPis) {
                    <span class="status-badge badge-azul ms-1">{{ exc.cstPis }}</span>
                    } @else { — }
                </p>
                <p class="mb-0"><strong>Período de Vigência:</strong> {{ exc.vigenciaTexto }}</p>
            </div>
        </div>
        }
    </div>
    }
</div>
